/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_List_Created_SuccessInputs */



/**
* | output |
* | --- |
* | "New list created successfully" |
*
* @param {New_List_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_list_created_success = /** @type {((inputs?: New_List_Created_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_List_Created_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle liste créée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Liste erfolgreich erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo elenco creato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый список успешно создан.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva lista creada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新列表已成功创建")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいリストが正常に作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई सूची सफलतापूर्वक बनाई गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nova lista criada com sucesso")
	return /** @type {LocalizedString} */ ("New list created successfully")
});